<div class="modal-header main-modal-header">
    <div *ngIf="companyListLoaded && !companies.length">
        <h4 class="modal-title" *ngIf="isFourDotFiveAdmin">
            No Companies Assigned
        </h4>
        <h4 class="modal-title" *ngIf="isSuperUser">
            No Companies Created
        </h4>
    </div>
    <h4 class="modal-title" *ngIf="companyListLoaded && companies.length">
        Select a company
    </h4>
</div>

<div class="modal-body companymodelbody" *ngIf="!companyListLoaded">
    <div class="col-xs-12">
        <app-skeleton-loader variant="block" [rows]="5"></app-skeleton-loader>
    </div>
</div>

<div class="modal-body companymodelbody" *ngIf="hasError">
    <p>Failed to load companies. Please try again.</p>
</div>

<div class="modal-body companymodelbody" *ngIf="companyListLoaded && !hasError && companies.length">

    <input type="text" class="pull-right text-center filter-style" style="padding-left: 2%;" placeholder="Search"
        [(ngModel)]="searchTerm.companyName" />

    <h3 style="padding-top: 3%;" *ngIf="isSuperUser">Host</h3>
    <div class="columns" *ngIf="isSuperUser">
        <ul *ngFor="let company of filterCompanies(hostCompanies)">
            <li class="company-item">
                <a (click)="getCompany(company)">{{company.companyName}}</a>
            </li>
        </ul>
    </div>

    <h3>Staffing Company</h3>
    <div class="columns">
        <ul *ngFor="let company of filterCompanies(staffingCompanies)">
            <li class="company-item">
                <a (click)="getCompany(company)">{{company.companyName}}
                    <span *ngIf="company.companyState !== 'Active'">
                        ({{company.companyStateLabel}})</span>
                    <sup *ngIf="company.vendor" class="text-danger vendor-indicator">V</sup>
                </a>
            </li>
        </ul>
    </div>

    <h3>Corporation</h3>
    <div class="columns">
        <ul *ngFor="let company of filterCompanies(corporationCompanies)">
            <li class="company-item">
                <a (click)="getCompany(company)">{{company.companyName}}
                    <span *ngIf="company.companyState !== 'Active'">
                        ({{company.companyStateLabel}})</span>
                </a>
            </li>
        </ul>
    </div>
</div>

<div class="modal-body companymodelbody" *ngIf="companyListLoaded && !companies.length">
    <main style="text-align: center;" *ngIf="isFourDotFiveAdmin">
        No Companies Assigned Yet.... Please Logout Now
    </main>
    <main style="text-align: center;" *ngIf="isSuperUser">
        No Companies Created Yet.... Create Now
    </main>
</div>

<div class="modal-footer" *ngIf="companyListLoaded">
    <a *ngIf="isSuperUser" (click)="addCompany()" class="btn btn-primary">
        Add company
    </a>
    <button *ngIf="!authService.userDetails?.company?.companySelected" [disabled]="disableLogoutButton"
        (click)="logoutAsNoCompaniesRelated()" class="btn btn-danger">
        <span>Logout</span>
    </button>
    <button *ngIf="authService.userDetails?.company?.companySelected" (click)="dismissModalAndDestroy()"
        class="btn btn-danger">
        <span>Cancel</span>
    </button>
</div>